import { render } from "./director_consent.html?vue&type=template&id=68bcbef0&external"
import script from "./director_consent.js?vue&type=script&lang=js&external"
export * from "./director_consent.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__